import React from 'react';
import { Grid, Typography } from '@mui/material';
import util from '../../utils/utils';

export const InfoGrid = ({ info, ...props }) => {
    return (
        <Grid container spacing={2}>
            {Object.keys(info).map((key) => (
                <Grid
                    item
                    xs={4}
                    container
                    direction="column"
                    key={key}
                    style={
                        (!info[key] && !info[key].render) || info[key].empty
                            ? { opacity: 0.3 }
                            : {}
                    }
                >
                    <Grid item>
                        <Typography
                            variant="caption"
                            style={{ fontSize: '0.7em', fontWeight: 'bold' }}
                            color={'primary'}
                        >
                            {util
                                .toTitleText(key)
                                .replace('Icd10 Code', ' ICD-10 Code')
                                .replace('Bmi', 'BMI')
                                .replace('Rounded BMI', 'BMI')
                                .replace('Trial Id', 'Trial ID')
                                .replace('Is Trial', 'Trial Participation')}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography style={{ fontSize: '0.9em' }}>
                            {info[key].empty
                                ? 'N/A'
                                : info[key] && info[key].render
                                ? info[key].render
                                : info[key] || 'N/A'}
                        </Typography>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default InfoGrid;
